import React, { Component, Fragment } from "react";

class HeaderComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			navmethod: false,
			cartmethod: false,
			infomethod: false,
			searchmethod: false,
		};
		this.toggleNav = this.toggleNav.bind(this);
		this.cartToggle = this.cartToggle.bind(this);
		this.infoToggle = this.infoToggle.bind(this);
		this.searchToggle = this.searchToggle.bind(this);
	}
	// Navigation
	toggleNav() {
		this.setState({
			navmethod: !this.state.navmethod,
		});
	}
	// Cart
	cartToggle(event, close = false) {
		console.log({ close });
		let cartmethod = close ? false : !this.state.cartmethod;
		this.setState({
			cartmethod,
		});

		if (cartmethod) {
			document.documentElement.style.overflowY = "hidden";
		} else {
			document.documentElement.style.overflowY = "scroll";
		}
	}

	initMap(coords) {
		if (window.google !== undefined) {
			let map = new window.google.maps.Map(document.getElementById("map"), {
				center: coords,
				zoom: 15,
			});

			new window.google.maps.Marker({
				position: coords,
				map,
				title: "",
			});
		}
	}
	infoToggle(coords) {
		let infomethod = !this.state.infomethod;
		this.setState({
			infomethod,
		});

		if (infomethod) {
			document.documentElement.style.overflowY = "hidden";
			this.initMap(coords);
		} else {
			document.documentElement.style.overflowY = "scroll";
		}
	}

	// Search
	searchToggle() {
		this.setState({
			searchmethod: !this.state.searchmethod,
		});
	}
	// Mobile menu
	getNextSibling = function (elem, selector) {
		// Get the next sibling element
		var sibling = elem.nextElementSibling;

		// If there's no selector, return the first sibling
		if (!selector) return sibling;

		// If the sibling matches our selector, use it
		// If not, jump to the next sibling and continue the loop
		while (sibling) {
			if (sibling.matches(selector)) return sibling;
			sibling = sibling.nextElementSibling;
		}
	};

	triggerChild = (e) => {
		let subMenu = "";

		subMenu =
			this.getNextSibling(e.target, ".submenu") !== undefined
				? this.getNextSibling(e.target, ".submenu")
				: null;

		if (subMenu !== null && subMenu !== undefined && subMenu !== "") {
			subMenu.classList = subMenu.classList.contains("d-block")
				? "submenu"
				: "submenu d-block";
		}
	};
	render() {
		return <Fragment />;
	}
}

export default HeaderComponent;
